import React, { useEffect, useRef, useState } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { getAllMemberProfileHistory } from '../../actions/memberAction';

import { useAuth } from '../../AuthProvider';
import { hideLoading, showLoading } from "../../actions/loaderAction";
import { buildPath, convertUTCToTzDate, showErrorMessage } from '../../utils/common';
import { isEmpty, size } from 'lodash';
import ToolipsCustom from '../../components/ToolipsCustom';
import NoDataFound from "../../components/common/NoDataFound";
import ReactPaginate from "react-paginate";
import Emitter from "../../utils/Emitter";
import { viewProfileAction } from '../../actions/viewProfileAction';
import ProfileHistoryViewFilter from './ProfileHistoryViewFilter';
import companylogo from "../../images/Company-logo.svg";
import defaultValues from '../../constant/defaultValues';
import SubHeader from '../../components/SubHeader';
import roles from '@/constant/roles.config';
import { privateRoutePaths } from '@/routes/private.route.config';
import { Tab, Row, Col, Nav } from "react-bootstrap";
import VisitedByMe from "../../components/profileHistory/VisitedByMe";
import VisitedByOthers from "../../components/profileHistory/VisitedByOthers";

function ProfileHistory(props) {

  const { id } = useParams();
  const companyID = id;
  const [searchParams, setSearchParams] = useSearchParams();
  const [pagination, setPagination] = useState([]);
  const [tableKey, setTableKey] = useState(0);
  const [memberList, setMemberList] = useState([]);
  const [limit, setLimit] = useState(6);
  const [current_page, setCurrentPage] = useState(1);
  const [nodata, setNoData] = useState(false);
  const [currentData, setCurrentData] = useState(null);
  const [disableProfile, setDisableProfile] = useState(false);
  const [activeKey, setActiveKey] = useState('visited-by-me');
  const [searchFilterObj, setSearchFilterObj] = useState({
    filter_val: null,
    findWhom: "All",
    selected_country: null,
    startDate: null,
    endDate: null
  });

  const { isEndUser, isDemoUser, isPreKYCUser, user, isViewer } = useAuth();
  const { IMAGE_PATH } = defaultValues;
  const tradeModeRef = useRef(null);
  const fetchCompanyProfile = async (id) => {

    await props.viewCompany(id).then(async (response) => {

      if (response.status) {

        if (!isEmpty(response.data)) {
          setCurrentData(response.data[0]);
          if (searchParams.get("history") === null) {
            if (response.data[0]?.trade_mode_type !== "LOG_PTR") {
              tradeModeRef.current = "BUYER_SUPPLIER";
              Emitter.emit("TRADE_MODE_TYPE", "BUYER_SUPPLIER");
            } else {
              tradeModeRef.current = "LOG_PTR";
              Emitter.emit("TRADE_MODE_TYPE", "LOG_PTR");
            }
          } else {
            let l = searchParams.get("history");
            let l1 = atob(l);
            if (l1 === "LOG") {
              tradeModeRef.current = "PAID_LEAD";
              Emitter.emit("TRADE_MODE_TYPE", "PAID_LEAD");
            }



          }


        }
      }
    }).catch((err) => {
      console.log("Error ============ ", err);

    });
  }

  const getProfileViewMembers = async (limit, current_page, filterObj) => {
    setNoData(false);
    await props.showLoading();
    await props.getAllMemberProfileHistory(companyID, limit, current_page, filterObj).then((response) => {
      if (size(response.data) === 0) {
        setNoData(true);
      }
      setMemberList(response.data);
      setPagination(response.pagination);
    }).catch((err) => {
      console.log("Error ==== ", err);
      showErrorMessage("Something went wrong");
    })
    await props.hideLoading();
  }

  const pageCount = Math.ceil(pagination.total / limit);

  useEffect(() => {
    fetchCompanyProfile(companyID);
    getProfileViewMembers(limit, current_page, searchFilterObj);
  }, []);

  const setProfileViewFilters = (newState) => {
    props.showLoading();
    newState.table_search = "";
    newState.current_page = 1;
    setCurrentPage(1);
  };

  const filterApplyOnProfileView = (filterObj) => {
    setSearchFilterObj(filterObj);
    getProfileViewMembers(limit, current_page, filterObj);
    setTableKey((prev) => prev + 1);
    props.hideLoading();
  };

  useEffect(() => {
    Emitter.on("FILTER_MEBER_VIEW_HISTORY", filterApplyOnProfileView);
    Emitter.on("SET_FILTER_MEBER_VIEW_HISTORY", setProfileViewFilters);
    return () => {
      Emitter.off("FILTER_MEBER_VIEW_HISTORY", filterApplyOnProfileView);
    };
  });

  const handlePageClick = (event) => {
    getProfileViewMembers(limit, event.selected + 1, searchFilterObj);

  };

  const getPrefix = () => {
    if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
    if (user && isDemoUser) return roles.DEMO.prefix;
    if (user && isEndUser) return roles.END_USER.prefix;
    if (user && isViewer) return roles.VIEWER.prefix;
    return roles.SUPER_ADMIN.prefix;
  };

  return (
    <div className=' new-design'>

      <div className='profile-history-log'>

        {tradeModeRef.current === "BUYER_SUPPLIER" && <SubHeader layer1="Supplier Directory" layer2={currentData?.company_name} layer3="Log" pageName={`Profile History - ${currentData?.company_name}`} subTitle=""
          clickable={{
            layer1: `/${getPrefix()}${privateRoutePaths.MANAGE_MEMBERS.path}`,
            layer2: `/${getPrefix()}${buildPath(privateRoutePaths.VIEW_COMPANY_PROFILE, { id: currentData?.id })}`,
            layer3: ""
          }}
        />}

        {tradeModeRef.current === "LOG_PTR" && <SubHeader layer1="Logistics Directory" layer2={currentData?.company_name} layer3="Log" pageName={`Profile History - ${currentData?.company_name}`} subTitle=""
          clickable={{
            layer1: `/${getPrefix()}${privateRoutePaths.MANAGE_LOGISTIC_MEMBERS.path}`,
            layer2: `/${getPrefix()}${buildPath(privateRoutePaths.VIEW_LOGISTIC_PROFILE, { id: currentData?.id })}`,
            layer3: ""
          }}
        />}

        {tradeModeRef.current === "PAID_LEAD" && <SubHeader layer1="Paid Members" layer2={currentData?.company_name} layer3="Log" pageName={`Profile History - ${currentData?.company_name}`} subTitle=""
          clickable={{
            layer1: `/${getPrefix()}${privateRoutePaths.MANAGE_PAID_MEMBERS.path}`,
            layer2: currentData?.trade_mode_type === 'LOG_PTR'
              ? `/${getPrefix()}${buildPath(privateRoutePaths.VIEW_LOGISTIC_PROFILE, { id: currentData?.id + "?lead=" + btoa("Paid") })}`
              : `/${getPrefix()}${buildPath(privateRoutePaths.VIEW_COMPANY_PROFILE, { id: currentData?.id + "?lead=" + btoa("Paid") })}`,
            layer3: ""
          }}
        />}


          <Tab.Container id="left-tabs-example" activeKey={activeKey} onSelect={(k) => setActiveKey(k)}>
          <Row>
            <Col sm={12} className="tab-menu">
              <div className="tab-menu-child custom-pills-padding">
                <Nav variant="pills" >
                  <Nav.Item>
                    <Nav.Link eventKey="visited-by-me" className="d-flex">
                      {/* <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20px"
                        height="22px"
                      >
                        <path
                          fillRule="evenodd"
                          fill="rgb(11, 68, 113)"
                          d="M19.631,22.000 L0.369,22.000 C0.165,22.000 -0.001,21.834 -0.001,21.629 C-0.001,21.424 0.165,21.258 0.369,21.258 L0.987,21.258 L0.987,7.292 C0.987,7.087 1.152,6.921 1.357,6.921 L4.444,6.921 L4.444,3.832 C4.444,3.627 4.609,3.461 4.814,3.461 L5.926,3.461 L5.926,1.854 C5.926,1.649 6.091,1.483 6.296,1.483 L7.901,1.483 L7.901,0.371 C7.901,0.166 8.067,-0.000 8.271,-0.000 C8.476,-0.000 8.642,0.166 8.642,0.371 L8.642,1.483 L10.247,1.483 C10.452,1.483 10.617,1.649 10.617,1.854 L10.617,3.461 L11.358,3.461 L11.358,1.854 C11.358,1.649 11.524,1.483 11.729,1.483 L18.643,1.483 C18.848,1.483 19.013,1.649 19.013,1.854 L19.013,21.258 L19.631,21.258 C19.835,21.258 20.001,21.424 20.001,21.629 C20.001,21.834 19.835,22.000 19.631,22.000 ZM4.197,21.258 L4.444,21.258 L4.444,20.641 C4.444,20.435 4.609,20.270 4.814,20.270 C5.019,20.270 5.185,20.435 5.185,20.641 L5.185,21.258 L5.432,21.258 L5.432,20.023 L4.197,20.023 L4.197,21.258 ZM1.728,7.663 L1.728,21.258 L3.456,21.258 L3.456,19.652 C3.456,19.447 3.622,19.281 3.827,19.281 L5.802,19.281 C6.007,19.281 6.172,19.447 6.172,19.652 L6.172,21.258 L7.901,21.258 L7.901,11.742 L7.901,7.663 L1.728,7.663 ZM9.877,2.225 L6.666,2.225 L6.666,3.461 L9.877,3.461 L9.877,2.225 ZM11.358,4.202 L5.185,4.202 L5.185,6.921 L8.271,6.921 C8.476,6.921 8.642,7.087 8.642,7.292 L8.642,7.416 L9.753,7.416 C9.958,7.416 10.124,7.582 10.124,7.787 C10.124,7.992 9.958,8.158 9.753,8.158 L8.642,8.158 L8.642,9.393 L9.753,9.393 C9.958,9.393 10.124,9.559 10.124,9.764 C10.124,9.969 9.958,10.135 9.753,10.135 L8.642,10.135 L8.642,11.371 L11.358,11.371 L11.358,4.202 ZM8.642,12.113 L8.642,21.258 L14.815,21.258 L14.815,12.113 L8.642,12.113 ZM18.272,2.225 L12.099,2.225 L12.099,11.371 L13.333,11.371 L13.333,11.247 C13.333,11.042 13.499,10.876 13.704,10.876 C13.909,10.876 14.074,11.042 14.074,11.247 L14.074,11.371 L14.815,11.371 L14.815,11.247 C14.815,11.042 14.981,10.876 15.186,10.876 C15.390,10.876 15.556,11.042 15.556,11.247 L15.556,21.258 L18.272,21.258 L18.272,2.225 ZM16.667,3.460 C16.872,3.460 17.038,3.626 17.038,3.831 L17.038,4.326 C17.038,4.531 16.872,4.696 16.667,4.696 C16.462,4.696 16.297,4.531 16.297,4.326 L16.297,3.831 C16.297,3.626 16.462,3.460 16.667,3.460 ZM16.667,5.932 C16.872,5.932 17.038,6.098 17.038,6.303 L17.038,6.798 C17.038,7.003 16.872,7.168 16.667,7.168 C16.462,7.168 16.297,7.003 16.297,6.798 L16.297,6.303 C16.297,6.098 16.462,5.932 16.667,5.932 ZM16.667,8.404 C16.872,8.404 17.038,8.570 17.038,8.775 L17.038,9.270 C17.038,9.475 16.872,9.641 16.667,9.641 C16.462,9.641 16.297,9.475 16.297,9.270 L16.297,8.775 C16.297,8.570 16.462,8.404 16.667,8.404 ZM16.667,10.876 C16.872,10.876 17.038,11.042 17.038,11.247 L17.038,11.742 C17.038,11.947 16.872,12.113 16.667,12.113 C16.462,12.113 16.297,11.947 16.297,11.742 L16.297,11.247 C16.297,11.042 16.462,10.876 16.667,10.876 ZM16.667,13.348 C16.872,13.348 17.038,13.514 17.038,13.719 L17.038,14.214 C17.038,14.418 16.872,14.584 16.667,14.584 C16.462,14.584 16.297,14.418 16.297,14.214 L16.297,13.719 C16.297,13.514 16.462,13.348 16.667,13.348 ZM16.667,15.820 C16.872,15.820 17.038,15.986 17.038,16.191 L17.038,16.685 C17.038,16.890 16.872,17.056 16.667,17.056 C16.462,17.056 16.297,16.890 16.297,16.685 L16.297,16.191 C16.297,15.986 16.462,15.820 16.667,15.820 ZM16.667,18.292 C16.872,18.292 17.038,18.458 17.038,18.663 L17.038,19.157 C17.038,19.362 16.872,19.528 16.667,19.528 C16.462,19.528 16.297,19.362 16.297,19.157 L16.297,18.663 C16.297,18.458 16.462,18.292 16.667,18.292 ZM15.186,9.641 C14.981,9.641 14.815,9.475 14.815,9.270 L14.815,8.775 C14.815,8.570 14.981,8.404 15.186,8.404 C15.390,8.404 15.556,8.570 15.556,8.775 L15.556,9.270 C15.556,9.475 15.390,9.641 15.186,9.641 ZM15.186,7.168 C14.981,7.168 14.815,7.003 14.815,6.798 L14.815,6.303 C14.815,6.098 14.981,5.932 15.186,5.932 C15.390,5.932 15.556,6.098 15.556,6.303 L15.556,6.798 C15.556,7.003 15.390,7.168 15.186,7.168 ZM15.186,4.696 C14.981,4.696 14.815,4.531 14.815,4.326 L14.815,3.831 C14.815,3.626 14.981,3.460 15.186,3.460 C15.390,3.460 15.556,3.626 15.556,3.831 L15.556,4.326 C15.556,4.531 15.390,4.696 15.186,4.696 ZM13.704,9.641 C13.499,9.641 13.333,9.475 13.333,9.270 L13.333,8.775 C13.333,8.570 13.499,8.404 13.704,8.404 C13.909,8.404 14.074,8.570 14.074,8.775 L14.074,9.270 C14.074,9.475 13.909,9.641 13.704,9.641 ZM13.704,7.168 C13.499,7.168 13.333,7.003 13.333,6.798 L13.333,6.303 C13.333,6.098 13.499,5.932 13.704,5.932 C13.909,5.932 14.074,6.098 14.074,6.303 L14.074,6.798 C14.074,7.003 13.909,7.168 13.704,7.168 ZM13.704,4.696 C13.499,4.696 13.333,4.531 13.333,4.326 L13.333,3.831 C13.333,3.626 13.499,3.460 13.704,3.460 C13.909,3.460 14.074,3.626 14.074,3.831 L14.074,4.326 C14.074,4.531 13.909,4.696 13.704,4.696 ZM13.210,20.517 C13.006,20.517 12.840,20.351 12.840,20.146 L12.840,13.224 C12.840,13.019 13.006,12.854 13.210,12.854 C13.415,12.854 13.581,13.019 13.581,13.224 L13.581,20.146 C13.581,20.351 13.415,20.517 13.210,20.517 ZM11.729,20.517 C11.524,20.517 11.358,20.351 11.358,20.146 L11.358,13.224 C11.358,13.019 11.524,12.854 11.729,12.854 C11.933,12.854 12.099,13.019 12.099,13.224 L12.099,20.146 C12.099,20.351 11.933,20.517 11.729,20.517 ZM10.247,20.517 C10.042,20.517 9.876,20.351 9.876,20.146 L9.876,13.224 C9.876,13.019 10.042,12.854 10.247,12.854 C10.451,12.854 10.617,13.019 10.617,13.224 L10.617,20.146 C10.617,20.351 10.451,20.517 10.247,20.517 ZM9.753,6.180 L6.790,6.180 C6.585,6.180 6.420,6.014 6.420,5.809 C6.420,5.604 6.585,5.438 6.790,5.438 L9.753,5.438 C9.958,5.438 10.124,5.604 10.124,5.809 C10.124,6.014 9.958,6.180 9.753,6.180 ZM6.296,18.045 C6.091,18.045 5.926,17.879 5.926,17.674 L5.926,17.179 C5.926,16.974 6.091,16.808 6.296,16.808 C6.501,16.808 6.667,16.974 6.667,17.179 L6.667,17.674 C6.667,17.879 6.501,18.045 6.296,18.045 ZM6.296,15.573 C6.091,15.573 5.926,15.407 5.926,15.202 L5.926,14.708 C5.926,14.503 6.091,14.337 6.296,14.337 C6.501,14.337 6.667,14.503 6.667,14.708 L6.667,15.202 C6.667,15.407 6.501,15.573 6.296,15.573 ZM6.296,13.101 C6.091,13.101 5.926,12.935 5.926,12.730 L5.926,12.236 C5.926,12.031 6.091,11.865 6.296,11.865 C6.501,11.865 6.667,12.031 6.667,12.236 L6.667,12.730 C6.667,12.935 6.501,13.101 6.296,13.101 ZM6.296,10.629 C6.091,10.629 5.926,10.463 5.926,10.258 L5.926,9.764 C5.926,9.559 6.091,9.393 6.296,9.393 C6.501,9.393 6.667,9.559 6.667,9.764 L6.667,10.258 C6.667,10.463 6.501,10.629 6.296,10.629 ZM4.814,18.045 C4.610,18.045 4.444,17.879 4.444,17.674 L4.444,17.179 C4.444,16.974 4.610,16.808 4.814,16.808 C5.019,16.808 5.185,16.974 5.185,17.179 L5.185,17.674 C5.185,17.879 5.019,18.045 4.814,18.045 ZM4.814,15.573 C4.610,15.573 4.444,15.407 4.444,15.202 L4.444,14.708 C4.444,14.503 4.610,14.337 4.814,14.337 C5.019,14.337 5.185,14.503 5.185,14.708 L5.185,15.202 C5.185,15.407 5.019,15.573 4.814,15.573 ZM4.814,13.101 C4.610,13.101 4.444,12.935 4.444,12.730 L4.444,12.236 C4.444,12.031 4.610,11.865 4.814,11.865 C5.019,11.865 5.185,12.031 5.185,12.236 L5.185,12.730 C5.185,12.935 5.019,13.101 4.814,13.101 ZM4.814,10.629 C4.610,10.629 4.444,10.463 4.444,10.258 L4.444,9.764 C4.444,9.559 4.610,9.393 4.814,9.393 C5.019,9.393 5.185,9.559 5.185,9.764 L5.185,10.258 C5.185,10.463 5.019,10.629 4.814,10.629 ZM3.333,18.045 C3.128,18.045 2.962,17.879 2.962,17.674 L2.962,17.179 C2.962,16.974 3.128,16.808 3.333,16.808 C3.537,16.808 3.703,16.974 3.703,17.179 L3.703,17.674 C3.703,17.879 3.537,18.045 3.333,18.045 ZM3.333,15.573 C3.128,15.573 2.962,15.407 2.962,15.202 L2.962,14.708 C2.962,14.503 3.128,14.337 3.333,14.337 C3.537,14.337 3.703,14.503 3.703,14.708 L3.703,15.202 C3.703,15.407 3.537,15.573 3.333,15.573 ZM3.333,13.101 C3.128,13.101 2.962,12.935 2.962,12.730 L2.962,12.236 C2.962,12.031 3.128,11.865 3.333,11.865 C3.537,11.865 3.703,12.031 3.703,12.236 L3.703,12.730 C3.703,12.935 3.537,13.101 3.333,13.101 ZM3.333,10.629 C3.128,10.629 2.962,10.463 2.962,10.258 L2.962,9.764 C2.962,9.559 3.128,9.393 3.333,9.393 C3.537,9.393 3.703,9.559 3.703,9.764 L3.703,10.258 C3.703,10.463 3.537,10.629 3.333,10.629 Z"
                        />
                      </svg> */}
                      <p className="ps-1 profile-tab">Visited By Me</p>
                    </Nav.Link>
                  </Nav.Item>

                  <Nav.Item>
                    <Nav.Link eventKey="visited-by-others" className="d-flex">
                      {/* <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22px"
                        height="22px"
                      >
                        <path
                          fillRule="evenodd"
                          fill="rgb(11, 68, 113)"
                          d="M15.764,4.548 C16.985,4.548 17.983,3.542 17.983,2.299 C17.983,1.056 16.990,0.050 15.764,0.050 C14.537,0.050 13.545,1.056 13.545,2.299 C13.545,3.542 14.537,4.548 15.764,4.548 ZM15.764,1.425 C16.242,1.425 16.627,1.820 16.627,2.299 C16.627,2.778 16.237,3.173 15.764,3.173 C15.291,3.173 14.901,2.778 14.901,2.299 C14.901,1.820 15.291,1.425 15.764,1.425 ZM12.266,11.189 L19.262,11.189 C19.636,11.189 19.937,10.884 19.937,10.505 L19.937,8.056 C19.937,6.344 18.565,4.953 16.876,4.953 L14.646,4.953 C12.957,4.953 11.585,6.344 11.585,8.056 L11.585,10.505 C11.585,10.884 11.887,11.189 12.261,11.189 L12.266,11.189 ZM12.942,8.056 C12.942,7.102 13.706,6.328 14.646,6.328 L16.876,6.328 C17.817,6.328 18.581,7.102 18.581,8.056 L18.581,9.820 L12.942,9.820 L12.942,8.056 ZM21.897,17.357 C21.684,16.477 20.639,15.514 19.797,14.860 C19.033,14.265 17.864,13.502 17.084,13.296 C16.517,13.149 16.200,13.333 16.034,13.517 C16.034,13.517 14.730,14.955 14.272,15.424 C14.199,15.498 13.976,15.498 13.700,15.424 C12.703,15.155 11.154,14.044 9.652,12.522 C8.150,10.1000 7.053,9.430 6.788,8.419 C6.715,8.140 6.715,7.913 6.788,7.840 C7.245,7.376 8.669,6.054 8.669,6.054 C8.851,5.886 9.033,5.564 8.888,4.990 C8.685,4.200 7.931,3.015 7.344,2.241 C6.700,1.388 5.749,0.329 4.881,0.113 C4.413,-0.003 3.976,0.124 3.675,0.466 L1.284,3.173 C0.031,4.590 -0.021,6.734 1.123,9.378 C2.074,11.569 3.805,14.002 6.003,16.225 C8.202,18.453 10.598,20.206 12.760,21.170 C14.002,21.723 15.135,22.002 16.133,22.002 C17.224,22.002 18.149,21.671 18.882,21.007 L21.554,18.584 C21.886,18.284 22.011,17.836 21.902,17.362 L21.897,17.357 ZM17.973,19.980 C16.746,21.097 14.750,20.559 13.300,19.912 C11.289,19.016 9.038,17.362 6.954,15.256 C4.875,13.149 3.243,10.863 2.360,8.825 C1.721,7.350 1.190,5.333 2.292,4.090 L4.615,1.461 C4.860,1.556 5.483,2.020 6.315,3.131 C7.027,4.084 7.427,4.874 7.552,5.233 C7.006,5.738 6.294,6.402 5.837,6.865 C5.530,7.176 5.218,7.755 5.483,8.772 C5.811,10.020 7.011,11.785 8.695,13.491 C10.379,15.198 12.120,16.414 13.352,16.746 C14.350,17.015 14.927,16.704 15.234,16.388 C15.691,15.924 16.346,15.203 16.845,14.650 C17.198,14.771 17.978,15.177 18.919,15.903 C20.020,16.751 20.478,17.378 20.566,17.626 L17.973,19.980 Z"
                        />
                      </svg> */}
                      <p className="ps-1 profile-tab">Visited By Others</p>
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </div>
            </Col>
          </Row>
          <Row>
              <Col sm={12}>
              <Tab.Content>
                  <Tab.Pane eventKey="visited-by-me">
                      <VisitedByMe type="ME" disableProfile={disableProfile} />
                  </Tab.Pane>
                  <Tab.Pane eventKey="visited-by-others">
                      <VisitedByOthers type="OTHER" disableProfile={disableProfile} />
                  </Tab.Pane>
              </Tab.Content>
              </Col>
          </Row>
        </Tab.Container>


        {/* <SubHeader layer1="Lead Management" layer2="List" layer3=""
                    pageName="Registration Leads 10"
                    clickable={{
                        layer1: "",
                        layer2: "",
                        layer3: ""
                    }}
                />
        <div className='sub-header'>
          <h3>Profile History - {currentData?.company_name}</h3>
        </div> */}

        {/* <p>Orex ID : {currentData?.member_unique_number}<b></b></p>
        <p></p> */}
        <div className='row'>

          <div className='col-12'>
            {/* <ProfileHistoryViewFilter /> */}
          </div>
          <div className='col-12'>
            {/* {memberList.length === 0 ? (

              <div className='card'>
                <NoDataFound />
              </div>
            ) : (
              <div className='list-wrape'>
                {memberList.map((item, index) => {
                  const m = item?.member?.[0];

                  if (!m) return null;

                  return (
                    <div key={item.id || index} className='list'>
                      <div className='left-date-label'>
                        <div className='label-date'>
                          <span className='date'>{convertUTCToTzDate(item.created_at, 'Etc/UTC', 'YYYY-MM-DD')}</span>
                          <span className='time'>{convertUTCToTzDate(item.created_at, 'Etc/UTC', 'hh:mm A')} <ToolipsCustom subtitle="Universal Time Coordinated" title={"UTC"}></ToolipsCustom></span>
                        </div>
                      </div>
                      <div className='right-data-wrape'>
                        <div className='card'>
                          <div className='user-pad'>
                            <div className='left-img'>
                              <div className="viewprofile-img-effect">
                                <img src={m && m.company_logo ? IMAGE_PATH.BASE_URL + '/company_logo/' + m.company_logo : companylogo} alt="" height={150} className='' />
                              </div>
                            </div>
                            <div className='right-detail'>
                              <div className='head-text'>
                                <h3>
                                  {m.company_name && m.id ? (
                                    <Link to={`/${getPrefix()}${buildPath(privateRoutePaths.VIEW_COMPANY_PROFILE, { id: m.id })}`} target="_blank">{(!isEmpty(m.company_name) ? m.company_name : "-")}</Link>
                                  ) : (
                                    <span>{(!isEmpty(m.company_name) ? m.company_name : "-")}</span>
                                  )}
                                  <span className='sub-text'>
                                    {(!isEmpty(m.member_city?.name) ? m.member_city.name + ', ' : "")}
                                    {(!isEmpty(m.country?.name) ? m.country.name : "-")}
                                  </span>
                                </h3>
                                <p>
                                  <b>Orex ID</b> {(!isEmpty(m.member_unique_number) ? m.member_unique_number : "-")}
                                </p>
                              </div>
                              <div className='data-wrape'>
                                <p>
                                  <span>Contact Person</span> {(!isEmpty(m.salutation) ? m.salutation + " " : "") + (!isEmpty(m.first_name) ? m.first_name + " " : "") + (!isEmpty(m.last_name) ? m.last_name : "")}
                                </p>
                                <p>
                                  <span>Designation</span> {(!isEmpty(m.designation) ? m.designation : "-")}
                                </p>
                                <p>
                                  <span>Email</span> {(!isEmpty(m.email) ? m.email : "-")}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}


              </div>
            )} */}

            {/* <div className="d-flex justify-content-between inquiry-pagination mt-5">
              {pagination.total > 0 && (<>
                <p>
                  showing <b>{pagination.from}</b> to <b>{pagination.to}</b> of <b>{pagination.total}</b>
                </p>

                <ReactPaginate
                  key={tableKey}
                  nextLabel=">"
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={2}
                  marginPagesDisplayed={2}
                  pageCount={pageCount}
                  previousLabel="<"
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link prev"
                  nextClassName="page-item"
                  nextLinkClassName="page-link next"
                  breakLabel="..."
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  containerClassName="pagination"
                  activeClassName="active"
                  renderOnZeroPageCount={null}
                />
              </>
              )}
            </div> */}
          </div>
        </div>

      </div>
    </div>
  );
}

const mapStateToProps = state => {

  return {

  }
}
const mapDispatchToProps = dispatch => {
  return {
    viewCompany: (companyID) => dispatch(viewProfileAction(companyID)),
    getAllMemberProfileHistory: (companyID, limit, current_page, filterObj) => dispatch(getAllMemberProfileHistory(companyID, limit, current_page, filterObj)),
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileHistory);